export const BILLING_PLAN_PACKAGES = {
  digital_agent: {
    packageId: "digital_agent",
    planType: "Digital Agent",
    amountLabel: "S$99 / month",
    title: "Digital Agent",
    description:
      "Professional Foundation. Basic lead tracking, 5 manual listings, and essential 2026 tax panels for the data-driven agent.",
    actionLabel: "Start Digital Agent Checkout",
  },
  alpha_investor: {
    packageId: "alpha_investor",
    planType: "Alpha Investor",
    amountLabel: "S$249 / month",
    title: "Alpha Investor",
    description:
      "Investment Authority. Portfolio Sync, Personal Agent Path, full Investor Cockpit, and Sales Command Center activity timelines.",
    actionLabel: "Upgrade to Alpha Investor",
  },
  elite_team: {
    packageId: "elite_team",
    planType: "Elite Team",
    amountLabel: "S$799 / month",
    title: "Elite Team",
    description:
      "Institutional Performance. Team management (5 seats), Lead Assignment, District Triage Radar (D9/10/15), and 2026 Compliance Tracker.",
    actionLabel: "Upgrade to Elite Team",
  },
};

export const getPackageIdForPlanType = (planType) => ({
  "Digital Agent": "digital_agent",
  "Alpha Investor": "alpha_investor",
  "Elite Team": "elite_team",
}[planType] || "digital_agent");

export const getPackageIdForFeature = (featureKey) => ({
  teamManagement: "elite_team",
  hotLeadAlerts: "elite_team",
  teamBranding: "elite_team",
  complianceTracker: "elite_team",
}[featureKey] || "alpha_investor");

export const getBillingPackage = (packageId) => BILLING_PLAN_PACKAGES[packageId] || BILLING_PLAN_PACKAGES.digital_agent;